/**
 * Route copy for `src/routes/influencers` (keys: `routes.influencers.<file>.<key>`).
 *
 * `fr` is the source; `en` and `ar` are typed against it, so a missing or extra
 * key fails `tsc` (and parity.test.ts). Keys are referenced from the route files
 * through `t()` / `tr()` — edit values freely, never rename a key without its call site.
 *
 * Locale file: en (typed against ./fr). One file per locale so
 * every non-default locale is a separate, lazily-loaded chunk.
 */

import type { Catalog } from './fr';

const en: Catalog = {
  influencerCampaignsPage: {
    influenceCampaignsFeature: 'Influencer campaigns',
    influencerShortlistsFeature: 'Influencer shortlists',
    theMoveFailed: 'The move failed.',
    memberRemoved: 'Member removed',
    deletionFailed: 'Deletion failed.',
    previousStep: 'Previous step',
    nextStep: 'Next step',
    removeName: 'Remove {{name}}',
    measurementAttribution: 'Measurement & attribution',
    noMeasurementAvailable: 'No measurement available',
    funnelAndAttributionIndicatorsWillAppear: 'Funnel and attribution indicators will appear here once a tracking source (pixel, UTM, manual entry) is available.',
    funnel: 'Funnel',
    noTrackingSource: 'no tracking source',
    calculationBasis: 'Calculation basis',
    attributedMetrics: 'Attributed metrics',
    notAttributable: 'not attributable',
    basisBasis: 'basis: {{basis}}',
    couldNotLoadTheCampaigns: 'Could not load the campaigns.',
    couldNotLoadTheCampaign: 'Could not load the campaign.',
    campaignCreatedDraft: 'Campaign created (draft)',
    theCreationFailed: 'The creation failed.',
    influencerAddedIdentified: 'Influencer added (identified)',
    addingFailed: 'Adding failed.',
    newCampaign: 'New campaign',
    name: 'Name',
    fallLaunch: 'Fall launch',
    objective: 'Objective',
    optional: 'Optional',
    awarenessSales: 'Awareness / sales',
    creating: 'Creating…',
    createDraft: 'Create (draft)',
    readOnlyRoleCreatingCampaignsIs: 'Read-only role: creating campaigns is reserved for authorized roles.',
    campaign: 'Campaign',
    noCampaigns: 'No campaigns',
    createACampaignToBuildIts: 'Create a campaign to build its influencer pipeline.',
    activeCampaign: 'Active campaign',
    influencer: 'Influencer',
    platform: 'Platform',
    handle: '@handle',
    account: '@account',
    add: 'Add',
    pipeline: 'Pipeline',
    noInfluencerInThePipeline: 'No influencer in the pipeline',
    addAnInfluencerAboveOrEnroll: 'Add an influencer above or enroll a candidate from the shortlist.',
    couldNotLoadTheShortlists: 'Could not load the shortlists.',
    shortlistCreated: 'Shortlist created',
    candidateAdded: 'Candidate added',
    newShortlist: 'New shortlist',
    beautyMicroInfluencers: 'Beauty micro-influencers',
    create: 'Create',
    readOnlyRoleManagingShortlistsIs: 'Read-only role: managing shortlists is reserved for authorized roles.',
    noShortlist: 'No shortlist',
    createAShortlistToGatherInfluencer: 'Create a shortlist to gather influencer candidates before enrolling them in a campaign.',
    noCandidates: 'No candidates.',
    followers: 'Followers:',
    notProvided: 'not provided',
    score: 'Score:',
    notComputed: 'not computed',
    cancel: 'Cancel',
    addACandidate: '+ Add a candidate',
    influencerCampaigns: 'Influencer campaigns',
    fromScoutingToMeasurementBuildShortlists: 'From scouting to measurement: build shortlists, steer each influencer on a stage board and track attribution — without made-up figures.',
    campaigns: 'Campaigns',
    shortlist: 'Shortlist',
    influencerCampaignSections: 'Influencer campaign sections',
    deleteTheCampaign: 'Delete the campaign',
    deleteCampaignAndPipelineIrreversible: 'Delete “{{name}}” and its pipeline? This action cannot be undone.',
    delete: 'Delete',
    campaignDeleted: 'Campaign deleted',
    shortlistDeleted: 'Shortlist deleted',
    deleteShortlistName: 'Delete the shortlist {{name}}',
    deleteTheShortlist: 'Delete the shortlist',
    deleteShortlistAndCandidatesIrreversible: 'Delete “{{name}}” and its candidates? This action cannot be undone.',
    readOnlyYourRoleCanViewButNotEdit: 'Read-only: your role can view campaigns, shortlists and measurements, but not edit them.',
  },
};

export default en;
